import React from 'react';
import * as BuilderUI from '../../../../../../components/Builder/BuilderUI';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import {
  significanceCriteriaSelector,
  significanceErrorSelector,
} from '../../../../../../redux/selectors/builder';
import {
  ICohortFieldsFragment,
  SignificanceModeKey,
} from '../../../../../../utils/apollo/graphqlSchema';
import { setSignificanceControlGroup } from '../../../../../../redux/slices/oldBuilder';
import { assertCondition } from '../../../../../../utils/types';
import SignificanceSegmentCriteriaField from './SignificanceSegmentCriteriaField';
import DndDroppableZone from '../../../../../../components/DndEntity/DndDroppableZone';
import { EntityDropzoneType } from '../../../../../../components/QuickAccessDictionary/DictionaryTabs/types';
import {
  EntityDropzoneDataTypeEnum,
  ISignificanceDropzoneDataType,
} from '../../../../../../components/DndEntity/validation';

const fieldsDropzoneId = `Significance-Control-Named-Cohort-Dropzone`;

const SignificanceSegmentControlGroup = () => {
  const dispatch = useAppDispatch();

  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'controlGroup'),
  );
  const significanceCriteria = useAppSelector(significanceCriteriaSelector);
  assertCondition(
    significanceCriteria?.modeKey === SignificanceModeKey.Segment,
  );
  const { controlGroup } = significanceCriteria;

  const handleChange = (value: ICohortFieldsFragment | null) => {
    dispatch(
      setSignificanceControlGroup({
        modeKey: significanceCriteria.modeKey,
        controlGroup: value,
      }),
    );
  };

  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>Control</BuilderUI.BuilderFieldLabel>
      <DndDroppableZone
        accepts={[EntityDropzoneType.Cohorts]}
        id={fieldsDropzoneId}
        data={
          {
            id: fieldsDropzoneId,
            type: EntityDropzoneDataTypeEnum.Significance,
          } satisfies ISignificanceDropzoneDataType
        }
        customMessage={'+ Add Cohort as Control'}
      >
        <SignificanceSegmentCriteriaField
          value={controlGroup}
          placeholder={'Select a named cohort as control'}
          onChange={handleChange}
          hasError={hasError}
        />
      </DndDroppableZone>
    </BuilderUI.BuilderFieldContainer>
  );
};

export default SignificanceSegmentControlGroup;
